import React, { Component } from 'react';
import styled from 'styled-components';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// REACT ROUTER
import { Redirect } from 'react-router-dom';

// Custom components
import CompanyInterfaceForm, {
    ComponentWrapper,
    FormWrapper,
    TopContainer,
} from 'containers/CompanyContainer/CompanyInterfaceForm';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';

// Constants
import { constants } from 'constants/index';

const InstructionsWrapper = styled.div`
    font: 24px Open Sans, Helvetica, sans-serif;
    color: ${constants.color.grey34};
`;

class ActivationCodeContainer extends CompanyInterfaceForm {
    state = {
        code: '',
        codeError: '',
    };

    submitCodeActivation = event => {
        event.preventDefault();
        // TODO implement error display
        this.props.checkActivationCode(this.state.code).then(success => {
            success
                ? console.log(
                      'Activation Code Was Correct. Activating Account.',
                  )
                : console.log('Activation Code Failed.');
        });
    };

    render() {
        const { code, codeError } = this.state;

        const isCodeValid = code =>
            code ? !code === '' || code.length === 8 : false;
        const getButtonStyles = isCodeValid =>
            !isCodeValid
                ? {
                      background: constants.color.grey5,
                      color: constants.color.grey34,
                  }
                : null;
        const buttonStyles = getButtonStyles(isCodeValid(code));

        return (
            <ComponentWrapper>
                <FormWrapper onSubmit={this.submitCodeActivation}>
                    <TopContainer>
                        <CompanyPageButton
                            test-label="saveButton"
                            type={'dark'}
                            size={'small'}
                            children={'Verify code'}
                            disabled={!isCodeValid(code)}
                            buttonStyle={buttonStyles}
                        />
                    </TopContainer>
                    <InstructionsWrapper>
                        Please input the code given to continue your account
                        activation
                    </InstructionsWrapper>
                    <FormTextField
                        label="Code"
                        name="code"
                        onChange={this.handleChange}
                        value={code}
                    />
                </FormWrapper>
            </ComponentWrapper>
        );
    }
}

export default connect(
    null,
    actions,
)(ActivationCodeContainer);



// WEBPACK FOOTER //
// ./src/js/containers/AccountActivation/ActivationCodeContainer.jsx